import React, { Component } from "react"
class MegaMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeIndex: -1
        }
    }

    handleMouseEnter = (indexValue) => {
        this.setState({ activeIndex: indexValue });
    }

    handleMouseLeave = () => {
        this.setState({ activeIndex: -1 });
    }

    render() {
        const categories = this.props.categories && this.props.categories.l1Categories && this.props.categories.l1Categories.slice(0, 8) || []
        return <div id="megamenu_gap"
        >
            <ul className="menus_list">
                {categories.map((categoryOuter, index) => {
                    const category = categoryOuter.allMeta || {}
                    return <div className="menus_list_inner" onMouseEnter={() => { this.handleMouseEnter(index) }}
                        onMouseLeave={this.handleMouseLeave}><li className="menus_list_item">
                            <a className="menus_list_item_anchor">{category.title}</a>
                        </li>
                        {index == this.state.activeIndex ?
                            <div className="menu_list_items_inner_outer container">
                                {category.children && category.children.map(innerCategory => {
                                    return <div className="menu_list_inner">
                                        <a className="menu_list_l2_header">{innerCategory.title}</a>
                                        <ul className="menus_list_sub_menu_list">
                                            {innerCategory.children && innerCategory.children.map(subInnerCategory => {
                                                return <li className="level_3_sub_category">{subInnerCategory.title}</li>
                                            })}
                                        </ul>
                                    </div>
                                })}
                            </div>
                            : null}
                    </div>
                })}
            </ul>
        </div>
    }
}

export default MegaMenu